<dropdown-v2
  [selectedItem]="selectedItem"
  [placeholder]="props.placeholder || ''"
  [disabledDropdown]="form.disabled || !!props.disabled || !!props.readonly"
  [items]="items"
  [isFilter]="props.isFilter"
  [wideItemsContainer]="true"
  [leftImgTpl]="leftImg"
  [attr.data-id]="field.dataId"
  (itemSelect)="optionSelected($event)"
  (collapse)="onCollapse($event)"
></dropdown-v2>

<ng-template #leftImg let-item="item">
  @if (item.extras?.type) {
    <credit-card-logo [creditCardType]="item.extras?.type" class="v2-mr-2"></credit-card-logo>
  }
</ng-template>
